import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';

const fmt = (n) => new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 }).format(n || 0);
const ESTADOS = { activo: '#34d399', vencida: '#fbbf24', cancelada: '#f87171', trial: '#6366f1' };

export default function AdminSuscripciones() {
  const [suscripciones, setSuscripciones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtro, setFiltro] = useState('');
  const [estadoFiltro, setEstadoFiltro] = useState('activo');
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/admin/suscripciones').then(r => setSuscripciones(r.data)).finally(() => setLoading(false));
  }, []);

  const filtradas = suscripciones.filter(s => {
    const q = filtro.toLowerCase();
    const matchTexto = !q || s.empresa?.toLowerCase().includes(q) || s.plan_nombre?.toLowerCase().includes(q);
    const matchEstado = !estadoFiltro || s.estado === estadoFiltro;
    return matchTexto && matchEstado;
  });

  const totalMRR = filtradas.filter(s => s.estado === 'activo').reduce((a, s) => a + (s.precio_pactado || 0), 0);

  return (
    <div style={{ padding: 28 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <div>
          <h1 style={{ margin: 0, fontSize: 22, fontWeight: 700, color: 'var(--text-1)' }}>Suscripciones</h1>
          <p style={{ margin: '4px 0 0', color: 'var(--text-3)', fontSize: 14 }}>
            MRR actual: <strong style={{ color: '#34d399' }}>{fmt(totalMRR)}</strong>
          </p>
        </div>
      </div>

      {/* Filters */}
      <div style={{ display: 'flex', gap: 12, marginBottom: 20 }}>
        <input
          placeholder="Buscar empresa, plan..."
          value={filtro}
          onChange={e => setFiltro(e.target.value)}
          style={{ flex: 1, padding: '9px 14px', borderRadius: 8, border: '1px solid var(--border)', background: 'var(--bg-card)', color: 'var(--text-1s)', fontSize: 14, outline: 'none' }}
        />
        {['', 'activo', 'trial', 'vencida', 'cancelada'].map(e => (
          <button key={e} onClick={() => setEstadoFiltro(e)}
            style={{ padding: '8px 16px', borderRadius: 8, border: 'none', cursor: 'pointer', fontSize: 13, fontWeight: 500,
              background: estadoFiltro === e ? '#6366f1' : '#1e293b',
              color: estadoFiltro === e ? '#fff' : '#64748b'
            }}
          >{e || 'Todos'}</button>
        ))}
      </div>

      {loading ? (
        <div style={{ textAlign: 'center', color: 'var(--text-3)', padding: 60 }}>Cargando...</div>
      ) : (
        <div style={{ background: 'var(--bg-card)', borderRadius: 12, border: '1px solid var(--border)', overflow: 'hidden' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: 'var(--bg-app)' }}>
                {['Empresa','Plan','Sillas','Precio','Ciclo','Inicio','Fin','Estado',''].map(h => (
                  <th key={h} style={{ padding: '12px 16px', textAlign: 'left', fontSize: 11, fontWeight: 600, color: 'var(--text-3)', textTransform: 'uppercase', letterSpacing: 0.5 }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtradas.map(s => {
                const diasRestantes = s.fecha_fin ? Math.ceil((new Date(s.fecha_fin) - new Date()) / 86400000) : null;
                return (
                  <tr key={s.id} style={{ borderTop: '1px solid var(--border)', cursor: 'pointer' }}
                    onMouseEnter={e => e.currentTarget.style.background = '#0f172a'}
                    onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                    onClick={() => navigate(`/superadmin/clientes/${s.cliente_id}`)}
                  >
                    <td style={{ padding: '14px 16px' }}>
                      <div style={{ fontWeight: 600, color: 'var(--text-1)', fontSize: 13 }}>{s.empresa}</div>
                      <div style={{ color: 'var(--text-3)', fontSize: 11 }}>{s.ciudad}</div>
                    </td>
                    <td style={{ padding: '14px 16px' }}>
                      <span style={{ padding: '3px 10px', borderRadius: 20, fontSize: 11, fontWeight: 600, background: (s.plan_color || '#64748b') + '22', color: s.plan_color || '#64748b' }}>{s.plan_nombre}</span>
                    </td>
                    <td style={{ padding: '14px 16px', color: 'var(--text-1s)', textAlign: 'center' }}>{s.sillas}</td>
                    <td style={{ padding: '14px 16px', color: '#22d3ee', fontWeight: 600 }}>{fmt(s.precio_pactado)}</td>
                    <td style={{ padding: '14px 16px', color: 'var(--text-2)', fontSize: 12 }}>{s.ciclo}</td>
                    <td style={{ padding: '14px 16px', color: 'var(--text-3)', fontSize: 12 }}>{s.fecha_inicio}</td>
                    <td style={{ padding: '14px 16px', fontSize: 12 }}>
                      {s.fecha_fin ? (
                        <span style={{ color: diasRestantes !== null && diasRestantes <= 30 ? '#fbbf24' : '#64748b' }}>
                          {s.fecha_fin} {diasRestantes !== null && diasRestantes <= 30 && <span>({diasRestantes}d)</span>}
                        </span>
                      ) : <span style={{ color: 'var(--text-4)' }}>-</span>}
                    </td>
                    <td style={{ padding: '14px 16px' }}>
                      <span style={{ fontSize: 11, padding: '2px 10px', borderRadius: 20, background: (ESTADOS[s.estado] || '#64748b') + '22', color: ESTADOS[s.estado] || '#64748b', textTransform: 'capitalize' }}>{s.estado}</span>
                    </td>
                    <td style={{ padding: '14px 16px' }}>
                      <button onClick={e => { e.stopPropagation(); navigate(`/superadmin/clientes/${s.cliente_id}`); }}
                        style={{ padding: '5px 12px', borderRadius: 6, border: '1px solid var(--border)', background: 'transparent', color: 'var(--text-2)', cursor: 'pointer', fontSize: 12 }}>Ver</button>
                    </td>
                  </tr>
                );
              })}
              {!filtradas.length && (
                <tr><td colSpan={9} style={{ padding: 40, textAlign: 'center', color: 'var(--text-4)' }}>No hay suscripciones</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
